export default [
  {
    userid: "1qe45g",
    senderid: "01",
    campid: "123",
    content: " Lorem ipsum is a placeholder text commonly used to demonstrate",
    submit: "yes",
    status: "Approved",
  },
  {
    userid: "1qe45g",
    senderid: "01",
    campid: "123",
    content: " Lorem ipsum is a placeholder text commonly used to demonstrate",
    submit: "yes",
    status: "Approved",
  },
];
